export default __webpack_public_path__ + "static/media/login-background.934ee201.png";